module.exports = __webpack_public_path__ + "static/media/LJ.18db10b.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/person/LJ.mp4
// module id = 7kwA
// module chunks = 1